import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { DataTable } from "primereact/datatable";
import CustomOverlayPanel from './CustomOverlayComponent';
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../Components/Loading";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PlanGroupActions from "../../Redux/transition/plan-group/plan-group.reducer";
import PaySwitchActions from "../../Redux/transition/payswitch/payswitch.reducer";
import PlanActions from "../../Redux/transition/plan/plan.reducer";
import PriceChange from "./priceChange";
import InviteSubscriber from "../Subscriptions/Invitation/InviteSubscriber";
import "../../Styles/pages/product.scss";
import "../../Styles/pages/inviteSubscriber.scss";
import PlanInfoEdit from "./PlanEdit";
import CustomToast from "../../Components/CustomToast";
import ProductInfoEdit from "./ProductEdit"
import MoveSubscriber from "./MoveSubscribers";
import ShareUrl from "./ShareUrl";
import SharePlan from "../../Components/SharePlan";
import OnboardingNotification from "../../Components/OnboardingNotification";
import SigningPendingNotice from "../../Components/SigningPendingNotice";
import GoLiveOutstandingDialog from "../../Components/GoLiveOutstandingDialog";
import { hasCurrentProviderCredentials } from "../../utils/pspOnboarding";
import { useDateFormatter } from "../../Components/FormatDateTime";
import { FormatCurrency, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import { ProductWatchers } from "./ProductWatchers";
import PlanAddRemoveWatcher from "./PlanAddRemoveWatcher"
import ProductGroupActions from "./ProductGroupActions";
import PlanTierActions from "./PlanTierActions";
import AutoBillingBadge from "../../Components/AutoBillingBadge";

const PRODUCTS_TABLE_MOBILE_BREAKPOINT = 1050;

const ProductDataTable = (props) => {

  const { formatDate } = useDateFormatter();
  const toast = useRef(null);

  const { doc, checked, filters, loadingTable,
    defMembership, loading, setTrigger, trigger, } = props;

  const archivingPlan = useSelector((state) => state.plans.archiving);
  const archivingPlanSuccess = useSelector((state) => state.plans.archiveSuccess);
  const archivingPlanError = useSelector((state) => state.plans.errorArchiving);
  const errorArchiving = useSelector((state) => state.planGroups.errorArchiving);
  const { duplicating, errorDuplicate, duplicate } = useSelector((state) => state.planGroups);
  const archiving = useSelector((state) => state.planGroups.archiving);
  const successArchiving = useSelector((state) => state.planGroups.archiveSuccess);
  const verificationStatus = useSelector((state) => state.documents.verifStatus);
  const fetchingVerifStatus = useSelector((state) => state.documents.fetchingVerifStatus);
  const signingPending = useSelector((state) => state.documents.signingPending);
  const business = useSelector((state) => state.businesses.business);
  const paymentCredentials = useSelector((state) => state.payswitch.credentials);
  const fetchingPaymentCredentials = useSelector((state) => state.payswitch.fetchingCredentials);
  const fetchingActivePlanGroups = useSelector((state) => state.planGroups.fetchingGraphedActive)
  const creatingLeaderBoard = useSelector((state) => state.planGroups.creatingLeaderBoard)
  const successLeaderBoard = useSelector((state) => state.planGroups.boardUrl)
  const errorLeaderBoard = useSelector((state) => state.planGroups.leaderBoardError);

  const dispatch = useDispatch();
  const archivePlanGroup = useCallback((planGroupId, username) => { dispatch(PlanGroupActions.planGroupArchiveRequest(planGroupId, username)); }, [dispatch]);
  const archivePlan = useCallback((planId, membershipId) => { dispatch(PlanActions.planArchiveRequest(planId, membershipId)); }, [dispatch]);
  const getActivePlanGroups = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedActiveRequest(businessId)); }, [dispatch]);
  const duplicatePlan = useCallback((id, name) => { dispatch(PlanGroupActions.planGroupDuplicateRequest(id, name)); }, [dispatch]);
  const getArchivedPlanGroups = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedArchivedRequest(businessId)) }, [dispatch])
  const getCredentials = useCallback((businessId, provider) => { dispatch(PaySwitchActions.paySwitchCredentialRequest(businessId, provider)) }, [dispatch]);
  const leaderBoard = useCallback((planGroupId) => { dispatch(PlanGroupActions.leaderBoardRequest(planGroupId)) }, [dispatch])


  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const credentialsSaved = hasCurrentProviderCredentials({
    credentials: paymentCredentials,
    provider: business?.pmtProvider,
  });

  const { currencyFormat, currencySymbol } = useCurrencyConstants();

  const [productInfoVisible, setProductInfoVisible] = useState({})
  const [showProductEditVisible, setShowProductEditVisible] = useState(false)
  const [planInfoVisible, setPlanInfoVisible] = useState({});
  const [toastData, setToastData] = useState({
    severity: '',
    summary: '',
    detail: '',
    life: null,
  });
  const [toastTrigger, setToastTrigger] = useState(false);
  const [reportable, setReportable] = useState(false);
  const op = useRef(null);
  const [visible, setVisible] = useState(false);
  const [tierArchive, setTierArchive] = useState(false);
  const [shareDialog, setShareDialog] = useState(false);
  const [sharePlanDialog, setSharePlanDialog] = useState(false);
  const [reportCode, setReportCode] = useState("");
  const [hideAmount, setHideAmount] = useState(false)
  const [expandedRows, setExpandedRows] = useState(null);
  const [dialogClosed, setDialogClosed] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [createLeaderboard, setCreateLeaderBoard] = useState(false);
  const [leaderboardId, setLeaderBoardId] = useState(false);
  const [viewWatcherPopup, setViewWatcherPopup] = useState(false)
  const [openWatcher, setOpenWatcher] = useState(false);
  const [product, setProduct] = useState(null)
  const [isMobileStack, setIsMobileStack] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= PRODUCTS_TABLE_MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${PRODUCTS_TABLE_MOBILE_BREAKPOINT}px)`);
    const onBreakpointChange = (event) => setIsMobileStack(event.matches);
    onBreakpointChange(mediaQuery);
    mediaQuery.addEventListener("change", onBreakpointChange);
    return () => mediaQuery.removeEventListener("change", onBreakpointChange);
  }, []);

  const [state, setState] = useState({
    documentsSelection: null,
    creatingPlanGroups: null,
    success: false,
    status: "ACTIVE",
    archiving: false,
    setDisplayBasic: false,
    tierVisible: false,
    priceVisible: false,
    cost: null,
    id: null,
    tierGroup: null,
    verificationStatus: null,
    business: null,
    visible: false,
    visiblePlan: false,
    hide: true,
    hidePlan: true,
    notOwnerVisible: false,
    initialTier: null,
    fetchingVerifRecord: true,
    rowId: null,
    rowData: null,
    archived: false,
    planArchiving: false,
    priceChange: false,
    changing: false,
    visibleMove: false,
    sourceTier: null,
    duplicate: null,
    duplicateName: "",
    shareDialog: false,
    shortUrl: null,
    copying: false,
    sharedPlan: {},
    planName: "",
    planDescription: "",
    sharedTier: {},
    paymentCredentials: null,
    confirmVisible: false,
    goLiveOutstandingVisible: false,
  });

  useEffect(() => {
    if (business?.verified && paymentCredentials === null) {
      getCredentials(business.id, business.pmtProvider)

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [business, paymentCredentials])

  useEffect(() => {
    if (!archivingPlan && state.planArchiving && archivingPlanSuccess) {
      showSuccess({
        message: t("product.planArchive_successful"),
        severity: "success",
      });
      setState((state) => ({ ...state, planArchiving: false }));
    }
    if (archivingPlan && state.planArchiving && archivingPlanError) { showError(); setState((state) => ({ ...state, planArchiving: false })); }
    if (!archiving && state.archived && successArchiving) { showSuccess({ message: t("product.archive_successful"), severity: "success", }); setState((state) => ({ ...state, archived: false })); }
    if (archiving && state.archived && errorArchiving) { showError(); setState((state) => ({ ...state, archived: false })); }
    if (!duplicating && state.duplicate && errorDuplicate) { showError(); setState((state) => ({ ...state, duplicate: null, duplicateName: "" })); }
    if (!duplicating && state.duplicate && duplicate) {
      showSuccess({ message: t("product.duplicate_success"), severity: "success", });
      setState((state) => ({ ...state, duplicate: null, duplicateName: "" }));
    }
    if (paymentCredentials) {
      setState((state) => ({ ...state, paymentCredentials }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [archiving, successArchiving, errorArchiving, state.archived, state.planArchiving, archivingPlan, archivingPlanSuccess, archivingPlanError, duplicating, errorDuplicate, paymentCredentials]);

  useEffect(() => {
    let loading = fetchingVerifStatus;
    setState((state) => { return { ...state, fetchingVerifRecord: loading }; });
    if (business) { setState((state) => ({ ...state, business: business })); }
    if (verificationStatus) { setState((state) => { return { ...state, verifStatus: verificationStatus }; }) }
  }, [fetchingVerifStatus, business, verificationStatus]);

  const leaderBoardError = (data) => {
    toast.current.show({
      severity: "error",
      summary: t("product.error_summary"),
      detail: t("products.leaderBoard_error"),
      life: 3000,
    });
  };


  useEffect(() => {
    if (createLeaderboard && creatingLeaderBoard) {
      setShareDialog(true);
    }

    if (!creatingLeaderBoard && successLeaderBoard && createLeaderboard) {
      getActivePlanGroups(defMembership.business.id);
      setState((prev) => ({
        ...prev,
        sharedTier: {
          shortUrl: successLeaderBoard.boardUrl,
          plan: `${t("product.leaderBoard_for")} ${successLeaderBoard.name}`,
          planGroupId: successLeaderBoard.id,
          isLeaderboard: true,
        },
      }));

      setCreateLeaderBoard(false);
    }

    if (!creatingLeaderBoard && errorLeaderBoard && createLeaderboard) {
      leaderBoardError();
      setShareDialog(false);
      setCreateLeaderBoard(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creatingLeaderBoard, successLeaderBoard, errorLeaderBoard, createLeaderboard]);



  const togglePriceChange = (data) => { setState({ ...state, priceVisible: true, cost: data.cost, id: data.id }); };
  const priceOnHide = () => { setState({ ...state, priceVisible: false }); };
  const onHide = () => { setState((state) => { return { ...state, visible: false }; }); };
  const toggleSetOpenDialog = () => { setOpenNotification(!openNotification); };
  const toggleOpenWatcherDialog = () => { setOpenWatcher(!openWatcher); };


  //   Toggle Invite Subscriber Dialogue Visibility
  const toogleInviteSubscriber = () => {
    if (fetchingVerifStatus) {
      return <Loading />;
    } else {
      if (business.verified && credentialsSaved && !signingPending) {
        setState((state) => { return { ...state, visible: true }; });
      } else if (signingPending && business.verified && credentialsSaved) {
        return openGoLiveOutstandingDialog();
      } else if (!business.verified || !business?.customPmtProvider) {
        if (state.verifStatus && !state.fetchingVerifRecord) { return openGoLiveOutstandingDialog(); }
        if (!state.verifStatus && !state.fetchingVerifRecord) {
          switch (defMembership.role) {
            case "OWNER":
              setOpenNotification(true)
              break;
            default:
              toggleNotOwnerDialogue();
          }
        }
      } else if (business.verified && !credentialsSaved) {
        return openGoLiveOutstandingDialog();
      }
    }
  };

  const toogleShareProduct = () => {
    if (fetchingVerifStatus || fetchingPaymentCredentials || fetchingActivePlanGroups) {
      return <Loading />;
    }
    if (signingPending && business.verified && credentialsSaved) {
      return openGoLiveOutstandingDialog();
    }
    if (!business?.customPmtProvider) {
      setOpenNotification(true);
    }
    else {
      if (!business.verified) {
        if (state.verifStatus && !state.fetchingVerifRecord) { return openGoLiveOutstandingDialog(); }
        if (!state.verifStatus && !state.fetchingVerifRecord) {
          switch (defMembership.role) {
            case "OWNER":
              setOpenNotification(true);
              break;
            default:
              toggleNotOwnerDialogue();
          }
        }
      }
      if (state.verifStatus && !paymentCredentials) {
        switch (defMembership.role) {
          case "OWNER":
            setOpenNotification(true)
            break;
          default:
            toggleNotOwnerDialogue();
        }
      }
    }
  };

  const toggleGoLiveOutstandingDialogue = () => {
    setState((state) => { return { ...state, goLiveOutstandingVisible: !state.goLiveOutstandingVisible }; });
  };
  const openGoLiveOutstandingDialog = () => {
    toggleGoLiveOutstandingDialogue();
  };

  //Toggle not Owner dialogue visibility
  const toggleNotOwnerDialogue = () => { setState((state) => { return { ...state, notOwnerVisible: !state.notOwnerVisible }; }); };

  const closeMoveSubscriber = () => { setState((state) => ({ ...state, visibleMove: false })); };
  const toggleMoveSubscriber = () => { setState((state) => ({ ...state, visibleMove: !state.visibleMove })); };

  const handleProductShare = (rowData, disableShare) => {
    if (disableShare) {
      return;
    }
    if (signingPending && business?.verified && credentialsSaved) {
      return openGoLiveOutstandingDialog();
    }
    if (credentialsSaved && !signingPending) {
      setSharePlanDialog(true);
      setDialogClosed(false);
      setReportable(rowData.reportable);
      setReportCode(rowData.reportCode);
      setHideAmount(rowData.hideAmount);
      setState((state) => ({
        ...state,
        sharedPlan: {
          shortUrl: rowData.shortUrl,
          plan: rowData.name,
          planDescription: rowData.description,
          planGroupId: rowData.id,
          reportable: rowData.reportable,
          reportCode: rowData.reportCode,
          hideAmount: rowData.hideAmount,
        },
      }));
    } else {
      toogleShareProduct();
    }
  };

  const handleProductEdit = (rowData) => {
    setProductInfoVisible(rowData);
    setState((state) => ({ ...state, rowData }));
  };

  const handleProductDuplicate = (rowData) => {
    setState((state) => ({
      ...state,
      duplicate: rowData.id,
      rowData,
    }));
  };

  const handleProductArchive = (rowData, e) => {
    e.stopPropagation();
    setVisible(true);
    setState((state) => ({ ...state, rowData }));
  };

  const handleProductLeaderboard = (rowData) => {
    if (rowData.boardUrl) {
      setShareDialog(true);
      setState((state) => ({
        ...state,
        sharedTier: {
          shortUrl: rowData.boardUrl,
          plan: `${t("products.leaderBoard_for")} ${rowData.name}`,
          planGroupId: rowData.id,
          isLeaderboard: true,
        },
      }));
    } else {
      setLeaderBoardId(rowData.id);
      setState({ ...state, confirmVisible: true });
    }
  };

  const handleProductWatchers = (rowData) => {
    setProduct(rowData);
    setViewWatcherPopup(true);
  };

  const handleTierShare = (rowData) => {
    if (signingPending && business?.verified && credentialsSaved) {
      return openGoLiveOutstandingDialog();
    }
    if (credentialsSaved && !signingPending) {
      setShareDialog(true);
      setState((state) => ({
        ...state,
        sharedTier: {
          shortUrl: rowData.shortUrl,
          plan: rowData.name,
          planDescription: rowData.description,
          planId: rowData.id,
        },
      }));
    } else {
      toogleShareProduct();
    }
  };

  const handleTierInvite = (rowData) => {
    toogleInviteSubscriber();
    setState((state) => ({ ...state, initialTier: { data: rowData } }));
  };

  const handleTierArchive = (rowData) => {
    setTierArchive(true);
    setState((state) => ({ ...state, rowData }));
  };

  const handleTierMoreActions = (rowData, e) => {
    setState((state) => ({ ...state, rowData }));
    op.current.toggle(e);
  };

  const handleTierWatchers = (rowData) => {
    setOpenWatcher(true);
    setState((state) => ({ ...state, rowData }));
  };

  const renderProductGroupActions = (rowData) => (
    <div className="products-action-cell">
      <ProductGroupActions
        rowData={rowData}
        onShare={handleProductShare}
        onEdit={handleProductEdit}
        onDuplicate={handleProductDuplicate}
        onArchive={handleProductArchive}
        onLeaderboard={handleProductLeaderboard}
        onWatchers={handleProductWatchers}
      />
    </div>
  );

  const renderPlanTierActions = (rowData) => (
    <PlanTierActions
      rowData={rowData}
      checked={checked}
      onShare={handleTierShare}
      onInvite={handleTierInvite}
      onArchive={handleTierArchive}
      onMoreActions={handleTierMoreActions}
      onWatchers={handleTierWatchers}
    />
  );

  //Dialog Footer for verif alert**
  const renderVerifFooter = (component, label = t("common.ok")) => {
    const checkPass = component === "not_owner";
    return (
      <div>
        <Button
          label={label}
          icon={checkPass && "pi pi-check"}
          style={{ backgroundColor: "#d0021b" }}
          autoFocus
          onClick={() => {
            toggleNotOwnerDialogue();
          }
          } />
      </div>
    );
  };

  const showSuccess = (data) => {
    setToastData({
      severity: "success",
      summary: t("success"),
      detail: data.message,
      life: 3000,
    });
    setToastTrigger(true);
  };

  const showError = () => {
    setToastData({
      severity: "error",
      summary: t("product.error_summary"),
      detail: t("product.archive_error"),
      life: 3000,
    });
    setToastTrigger(true);
  };

  const handleActionsAfterToast = () => {
    getActivePlanGroups(defMembership.business.id);
    getArchivedPlanGroups(defMembership.business.id);
    setVisible(false);
    setToastTrigger(false);
  }


  const accept = () => {
    if (tierArchive) {
      setState((state) => ({ ...state, planArchiving: true }));
      archivePlan(state.rowData.id, defMembership.id);
      setTierArchive(false);
    } else {
      setState((state) => ({ ...state, archived: true }));
      archivePlanGroup(state.rowData.id, defMembership.user.login);
    }
  };

  const reject = () => {
    setVisible(false);
    setTierArchive(false);
  };

  const archiveFooter = () => {
    return (
      <div>
        <Button
          id="footer-btn-cancel"
          label={t("cancel")}
          icon="pi pi-times"
          onClick={reject}
        />
        <Button
          id="archive-btn"
          loading={archiving}
          label={t("share.archive")}
          icon="pi pi-check"
          onClick={accept}
        />
      </div>
    );
  };

  const duplicateFooter = () => {
    return (
      <div className="duplicate-footer">
        <Button
          id="footer-btn-cancel"
          label={t("cancel")}
          icon="pi pi-times"
          onClick={() => {
            setState((state) => {
              return { ...state, duplicate: null };
            });
          }}
        />
        <Button
          loading={duplicating}
          style={{ backgroundColor: "#D0021B", fontWeight: "bold" }}
          onClick={() => {
            if (state.duplicate && state.duplicateName) {
              duplicatePlan(state.duplicate, state.duplicateName);
            } else {
              setState((state) => ({ ...state, duplicateName: null }));
            }
          }}
        >
          {t("duplicate")}
        </Button>
      </div>
    );
  };

  const renderProductCreatedDates = (rowData) => {
    const createdOn = rowData ? formatDate(rowData.createdOn) : "";
    const lastModifiedDate = rowData ? formatDate(rowData.lastModifiedDate) : "";

    if (createdOn === lastModifiedDate) {
      return createdOn ? (
        <div style={{ display: "flex", textAlign: "left" }}>
          <span className="detail-navigatio" id="createdOn create">
            {createdOn}
          </span>
        </div>
      ) : null;
    }

    return (
      <>
        {createdOn ? (
          <div style={{ display: "flex", textAlign: "left" }}>
            <span className="detail-navigatio" id="createdOn create">
              {createdOn}
            </span>
          </div>
        ) : null}
        {lastModifiedDate ? (
          <div style={{ paddingTop: "0.4rem" }}>
            <span className="product_date">{t("product.updated_on")}{":"}</span>{" "}
            <span className="productModifiedDate">
              {lastModifiedDate}
            </span>
          </div>
        ) : null}
      </>
    );
  };

  const subscriptionBodyTemplate = (rowData) => {
    if (rowData) {
      return (
        <div className="subscription-body">
          {rowData.name ? (
            <span
              className="name-body"
              id="productName"
              onClick={() => {
                navigate(`/products/detail/${rowData.id}`)
              }}
            >
              {" "}
              {rowData.name}{" "}
            </span>
          ) : null}
          {rowData.description ? (
            <span className="name-body" id="planDesc">
              {rowData.description}
            </span>
          ) : null}
          {rowData ? (
            <span className="name-body" id="planNam">
              {rowData.exclusive ? (
                <span className="exclusive">{t("product.exclusive")}</span>
              ) : (
                <span className="non-exclusive">
                  {t("product.non_exclusive")}
                </span>
              )}
            </span>
          ) : null}
          {isMobileStack && (
            <div className="products-mobile-created createdOnBodyTemplate">
              {renderProductCreatedDates(rowData)}
            </div>
          )}
          {isMobileStack && !checked && (
            <div className="products-mobile-action-row">
              {renderProductGroupActions(rowData)}
            </div>
          )}
        </div>
      );
    }
  };

  const createdOnTemplate = (rowData) => {
    if (rowData) {
      return (
        <div className="createdOnBodyTemplate">
          {renderProductCreatedDates(rowData)}
        </div>
      );
    }
  };

  const archiveTemplate = (rowData) => {
    if (rowData.status === "ARCHIVED") {
      return (
        <div className="car-buttons archive_container">
          <Button
            icon="pi pi-lock"
            style={{ color: "#FDC237", cursor: "default" }}
            className="p-button action-button archive_icon"
            id="action-button"
          />
        </div>
      );
    }
  };

  const toogleConfirmInviteSubscriber = () => {
    setState(state => { return { ...state, confirmVisible: !state.confirmVisible } })
  }

  const hideWatcherPopup = () => {
    setViewWatcherPopup(false);
    getActivePlanGroups(defMembership.business.id);
  }

  const hideInvite = () => {
    toogleConfirmInviteSubscriber()
    setState({ ...state, checking: false, success: false, requesting: false, confirmVisible: false })
  }

  const rejectInvite = () => {
    setState({ ...state, checking: false, success: false, requesting: false, confirmVisible: false, })
  }

  const planInfoTemplate = (rowData) => {
    if (rowData) {
      return (
        <div className="plan-info-main">
          <div style={{ margin: "0.3rem 0rem 0.8rem 0rem" }}>
            {rowData.policy ? (
              <div className="flex" style={{ paddingBottom: "0.2rem" }}>
                {rowData.policy === "TARGET" ?
                  (<>
                    <p className="text-left policy mb-0 mr-2">{t('billing', { val: rowData.policy })}</p>
                    <p className="text-left policy target-stat mb-0 mr-1">{rowData.targetEqualParts ? t("product.equal") : t("product.varying")}</p>
                    {(rowData.targetEqualParts && rowData.recoverMissed) && <p className="text-left policy target-stat-miss mb-0">{t('product.recovery')}</p>}
                  </>
                  ) :
                  <p className="text-left policy mb-0">{rowData.policy === "FIXED" ? t("products.fixed_billing").toUpperCase() : rowData.policy === "CUSTOM" ? t("products.custom_billing").toUpperCase() : t('billing', { val: rowData.policy })}</p>
                }
              </div>
            ) : null}
            <div>
              {
                <div className="plan-amt">
                  <span className="planCost mt-0">
                    {(rowData.policy === "CUSTOM" && !rowData.cost) ? t("amount_fixed") : (rowData.policy === "TARGET") ? t("products.target-fixed") : (rowData.policy === "FLEXIBLE") ? t("products.flexible-amount")
                      : (rowData.policy === "FIXED" && rowData.cost &&
                        <FormatCurrency
                          amount={rowData.cost}
                          currencySymbol={currencySymbol}
                          currencyFormat={currencyFormat}
                          className="plan-cost mt-0"
                        />
                      )
                    }
                  </span>
                  {rowData.policy === "FIXED" && rowData?.cost === null && <p></p>}
                </div>
              }
              <span className="planBillingPeriod pb-0 pt-0">
                {t(`product.${rowData.billingPeriod.toLowerCase()}`)}
              </span>
            </div>

            <div>
              {rowData.deductions !== null && (
                rowData.cost === null && rowData.policy === "FIXED" ?
                  null
                  : <div className="text-left">
                    <p id="deductions-text" style={{ color: "#23547B", fontSize: "12px", paddingRight: "0.2rem", fontWeight: "bold" }}>
                      {rowData.deductions > 1 ?
                        t("product.deduction-val_plural", { count: rowData.deductions })
                        : t("product.deduction-val", { count: rowData.deductions })}</p>
                  </div>
              )}
            </div>
          </div>

          {rowData.setup && <div className="setup_fee_div" id="setup-m-b">
            <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
            <FormatCurrency
              amount={rowData.setup}
              currencySymbol={currencySymbol}
              currencyFormat={currencyFormat}
              className="setup_fee_value"
            />
          </div>}
          <div>{rowData.graceDays === null || rowData.graceDays === 0 ? "" :
            <div style={{ display: "flex", flexDirection: "row", paddingBottom: "0.2rem" }}>
              <span className="graceDaysLabel">{t("product.graceDaysLabel")}{":"}</span>
              <span className="planGraceDays">{rowData.graceDays} {" "}{rowData.graceDays ? t("products.day") : null}
              </span>
            </div>}
          </div>
          <div>
            {rowData.reminderDays === null || rowData.reminderDays === 0 ? <div></div> :
              <div style={{ display: "flex", flexDirection: "row" }}>
                <span className="reminderDaysLabel">{t("product.reminderDaysLabel")}{":"}</span>
                <span className="planReminderDays">{rowData.reminderDays}{" "}{rowData.reminderDays ? t("products.day") : null}</span>
              </div>}
          </div>
        </div >
      );
    }
  };

  const tierArchiveTemplate = (rowData) => {
    if (props.checked || rowData.status === "ARCHIVED") {
      return (
        <div
          className="tier-archive-button" >
          <Button
            icon="pi pi-lock"
            className="p-button action-button"
            id="archived_icon"
          />
        </div>
      );
    }
  };

  const renderTierCreatedDates = (rowData) => {
    const createdOn = rowData?.createdDate ? formatDate(rowData?.createdDate) : "";
    const lastModified = rowData?.lastModifiedDate ? formatDate(rowData?.lastModifiedDate) : "";

    if (createdOn === lastModified) {
      return createdOn ? <span className="createdDate">{createdOn}</span> : null;
    }

    if (createdOn !== lastModified) {
      return (
        <>
          <span className="createdDate"> {createdOn}</span>
          <div className="datesMod">
            <span className="product_date">{t("product.updated_on")}{":"}</span> &nbsp;
            <span className="productModifiedDate">{lastModified}</span>
          </div>
        </>
      );
    }

    return null;
  };

  const datesTemplate = (rowData) => {
    const dateContent = renderTierCreatedDates(rowData);
    return dateContent ? <div>{dateContent}</div> : null;
  };

  const columns = [
    {
      field: "name",
      body: subscriptionBodyTemplate,
      header: t("product.table_name"),
      className: `name-body products-name-column${isMobileStack ? " products-mobile-summary-column products-mobile-expander-sibling" : ""}`,
    },
    ...(!isMobileStack
      ? [{
        field: "createdColumn",
        body: createdOnTemplate,
        header: t("product.created"),
        sort: true,
        className: "products-created-column",
      }]
      : []),
    ...(!checked && !isMobileStack
      ? [{
        field: "customer",
        body: renderProductGroupActions,
        header: t("common.actions"),
        className: "products-action-column",
      }]
      : []),
  ];

  const rowClass = (data) => {
    return {
      archivedTier: data.status === "ARCHIVED",
      changePriceDisabled:
        data.policy !== "FIXED" || (data.policy === "FIXED" && data.flex),
    };
  };

  const tierNameTemplate = (rowData) => {
    if (rowData) {
      return (
        <div className={rowData.description ? "plan-template" : "plan-no-desc"}>
          {rowData.name ? (
            <div className="flex align-items-center gap-2">
              <p
                className="name-body"
                id="plan_name"
                onClick={() => {
                  navigate(`/products/plan/detail/${rowData.id}`)
                }}
              >
                {rowData.name}
              </p>
              <AutoBillingBadge collectionMode={rowData.collectionMode} />
            </div>
          ) : null}
          <p className="plan-desc">{rowData.description}</p>
          {isMobileStack && (
            <div className="products-mobile-created">
              {renderTierCreatedDates(rowData)}
            </div>
          )}
          {isMobileStack && !checked && rowData.status !== "ARCHIVED" && (
            <div className="products-mobile-action-row">
              {renderPlanTierActions(rowData)}
            </div>
          )}
        </div>
      );
    }
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div>
        <Dialog
          header={t("products.archive_header_plan")}
          visible={tierArchive}
          onHide={() => setTierArchive(false)}
          footer={archiveFooter()}
          className="tier_dialog"
          id="tier_dialog"
          style={{ width: "300px" }}
        >
          <div className="archive-dialog-content">
            <p style={{ display: "flex", justifyContent: "center" }}>
              <i
                className="pi pi-exclamation-circle"
                style={{
                  color: "#D0021B",
                  fontSize: "40px",
                  fontWeight: "bolder",
                }}
              />
            </p>
            <div style={{ padding: "10px" }}>
              <div style={{ marginBottom: "0.5rem" }}>
                <span>
                  {t("products.archive_question_plan")}{" "}
                  <span style={{ fontWeight: "bold", color: "#000" }}>
                    {state.rowData?.name}
                  </span>{"?"}{" "}
                </span>
              </div>
              <p className="archive-notice">
                {t("product.archive_notice")}
              </p>
            </div>
            <hr style={{ border: "1px solid #F2F2F2" }} />
          </div></Dialog>

        <h6 className="group-name products-plans-heading">
          {t("products.plans")}
        </h6>
        <DataTable
          sortField="createdDate"
          sortOrder={-1}
          id="expanded-table"
          className={`p-datatable-responsive-table expanded `}
          rowClassName={rowClass}
          value={data.tiers}
          responsiveLayout="stack"
          breakpoint="1050px"
          dataKey="id"
        >
          {(!isMobileStack || checked) && (
            <Column
              alignHeader="left"
              field="createdOn"
              body={(rowData) => tierArchiveTemplate(rowData)}
              className={`datatable-cell-default ${checked && "archive-cell"} ${!checked && "archive-column"
                } archive-icon`}
              headerClassName="datatable-header-default header-style"
            ></Column>
          )}
          <Column
            alignHeader="left"
            field="name"
            body={(rowData) => tierNameTemplate(rowData)}
            filterField="name"
            id="tierNameColumn"
            header={t("product.plan_table_name")}
            className={`datatable-cell-default products-name-column${isMobileStack ? " products-mobile-summary-column products-mobile-expander-sibling" : ""} ${checked && "archive-cell"} ${!checked && "archive-column"
              }`}
            headerClassName="datatable-header-default"
          ></Column>
          {!isMobileStack && (
            <Column
              alignHeader="left"
              header={t("product.created")}
              sortable
              body={(rowData) => datesTemplate(rowData)}
              className={`datatable-cell-default products-created-column ${checked && "archive-cell"} ${!checked && "archive-column"} `}
              headerClassName="datatable-header-default"
            ></Column>
          )}
          {!isMobileStack && (
            <Column
              alignHeader="left"
              field="cost"
              header={t("product.plan_info")}
              sortable
              body={(rowData) => planInfoTemplate(rowData)}
              className={`datatable-cell-default ${checked && "archive-cell"} ${!checked && "archive-column"
                } `}
              headerClassName="datatable-header-default"
            ></Column>
          )}

          {!isMobileStack && (
            <Column
              field="actionColumn"
              id="actionColumn"
              header={t("common.actions")}
              body={(rowData) => <div className="products-action-cell">{renderPlanTierActions(rowData)}</div>}
              className={`datatable-cell-default products-action-column ${checked && "archive-cell"}  ${!checked && "archive-column"
                }`}
              headerClassName="datatable-header-default"
            ></Column>
          )}
        </DataTable>
      </div >
    );
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Toast
            ref={toast}
          />
          <OnboardingNotification
            visible={openNotification}
            onHide={toggleSetOpenDialog} />
          <ShareUrl
            visible={shareDialog}
            setShareDialog={setShareDialog}
            sharedTier={state.sharedTier}
            leaderBoard={Boolean(state.sharedTier?.isLeaderboard)}
            copying={state.copying}
            generating={creatingLeaderBoard || fetchingActivePlanGroups}
            defMembership={defMembership}
            onLeaderboardRemoved={() => {
              getActivePlanGroups(defMembership.business.id);
            }}
          />
          <SharePlan
            visible={sharePlanDialog}
            setSharePlanDialog={setSharePlanDialog}
            defMembership={defMembership}
            sharedPlan={state.sharedPlan}
            reportable={reportable}
            reportCode={reportCode}
            setReportCode={setReportCode}
            hideAmount={hideAmount}
            dialogClosed={dialogClosed}
            setDialogClosed={setDialogClosed}
          />
          <PlanInfoEdit
            tier={planInfoVisible}
            onHide={() => setPlanInfoVisible({})}
            setTrigger={setTrigger}
            trigger={trigger}
          />
          <ProductInfoEdit
            product={productInfoVisible}
            onHide={() => setProductInfoVisible({})}
            showProductEdit={showProductEditVisible}
            setShowProductEdit={setShowProductEditVisible}
          />

          <ProductWatchers {...{ viewWatcherPopup, hideWatcherPopup, product }} />

          <CustomOverlayPanel op={op}>
            <div>
              <ul className="user-profile-items">
                <li>
                  <div
                    onClick={() => {
                      setPlanInfoVisible(state.rowData);
                    }}
                    className="p-link list-button"
                  >
                    <span className="list-items">{t("products.edit_plan_info")}</span>
                  </div>
                </li>
              </ul>
              {state.rowData?.policy === "FIXED" && !state.rowData?.flex && (
                <ul className="user-profile-items">
                  <li>
                    <div
                      className="p-link list-button"
                      onClick={() => {
                        togglePriceChange(state.rowData);
                      }}
                    >
                      <span className="list-items">
                        {t("product.change_price_1")}
                      </span>
                    </div>
                  </li>
                </ul>
              )}
              <ul className="user-profile-items">
                <li>
                  <div
                    className="p-link list-button"
                    onClick={() => {
                      toggleMoveSubscriber();
                      setState((state) => {
                        return { ...state, sourceTier: { data: state.rowData } };
                      });
                    }}
                  >
                    <span className="list-items">{t("product.migrate")}</span>
                  </div>
                </li>
              </ul>
            </div>
          </CustomOverlayPanel>

          {(state.confirmVisible) &&
            <ConfirmDialog visible={state.confirmVisible} onHide={hideInvite} className="confirm_close_btn" id="leaderboard_dialog"
              message={<div style={{ marginTop: "0.6rem" }}>
                <span className="confirm_invite_detail detail">{t("product.leaderboard_confirm_message")}</span>

              </div>}
              header={t("product.leaderboard_confirm_header")}
              acceptLabel={t("product.leaderboard_confirm_accept")}
              rejectLabel={t("product.leaderboard_confirm_reject")}
              accept={() => {
                leaderBoard(leaderboardId)
                setCreateLeaderBoard(true)
              }} reject={rejectInvite} />
          }

          <PriceChange
            toggle={togglePriceChange}
            toggleState={state.priceVisible}
            oldPrice={state.cost?.toFixed(2)}
            id={state.id}
            onHide={priceOnHide}
            defMembership={defMembership}
          />
          <MoveSubscriber
            visible={state.visibleMove}
            onHide={closeMoveSubscriber}
            sourceTier={state.sourceTier}
          />
          <Dialog
            header={t("product.duplicate")}
            className="tier_dialog"
            id="tier_dialog"
            style={{ width: "350px" }}
            footer={duplicateFooter}
            visible={!!state.duplicate}
            onHide={() => setState((state) => ({ ...state, duplicate: null }))}
          >
            <div
              className="flex flex-column gap-2 mb-4"
              style={{ padding: "10px 10px 0px 10px" }}
            >
              <span style={{ color: "#7D8186" }}>
                {t("product.duplicate_header")}{" "}
                <span style={{ fontWeight: "bold", color: "#000" }}>
                  {state.rowData?.name}
                </span>{" "}
                {t("product.dup_header")}
              </span>
              <hr style={{ border: "2px solid #F2F2F2" }} />
              <label
                style={{
                  fontFamily: "Roboto",
                  fontWeight: "bold",
                  color: "#666678",
                }}
              >
                {t("products.new_name")}
              </label>
              <InputText
                style={{ height: "3rem", borderRadius: "4px" }}
                value={state.duplicateName}
                onChange={(e) =>
                  setState((state) => ({
                    ...state,
                    duplicateName: e.target.value,
                  }))
                }
                maxLength={50}
              />
              {state.duplicateName === null && (
                <span className="p-error">{t("products.validate_error")}</span>
              )}
            </div>
          </Dialog>
          <GoLiveOutstandingDialog
            visible={state.goLiveOutstandingVisible}
            onHide={toggleGoLiveOutstandingDialogue}
          />
          <Dialog
            header={t("idoc.not_owner_header")}
            visible={state.notOwnerVisible}
            style={{ width: "360px" }}
            onHide={toggleNotOwnerDialogue}
            footer={renderVerifFooter("not_owner")}
          >
            <p className="dialog_text">{t("idoc.not_owner_payment_text1")} <span className="not_owner_bold_text">{t("idoc.not_admin_owner_text")}</span> {t("idoc.not_owner_payment_text2")} <span className="not_owner_bold_text">{t("idoc.not_owner_admin_text")}</span> {t("idoc.not_owner_payment_text3")} </p>
            <SigningPendingNotice business={business} />
          </Dialog>
          <InviteSubscriber
            visible={state.visible}
            onHide={onHide}
            initialTier={state.initialTier}
            toggleVisible={state.visible}
            setVisibleInvite={toggleSetOpenDialog}
            callbackFunctions={() => { }}
          />

          <PlanAddRemoveWatcher
            visible={openWatcher}
            onHide={toggleOpenWatcherDialog}
            selectedPlan={state.rowData}
          />

          <CustomToast
            {...toastData}
            trigger={toastTrigger}
            handleActionsAfterToast={handleActionsAfterToast}
          />
          <Dialog
            header={t("Archive")}
            visible={visible}
            onHide={() => setVisible(false)}
            footer={archiveFooter()}
            className="tier_dialog"
            id="tier_dialog"
            style={{ width: "350px" }}
          >
            <div className="archive-dialog-content">
              <p style={{ display: "flex", justifyContent: "center" }}>
                <i
                  className="pi pi-exclamation-circle"
                  style={{
                    color: "#D0021B",
                    fontSize: "40px",
                    fontWeight: "bolder",
                  }}
                />
              </p>
              <div style={{ padding: "10px" }}>
                <div style={{ marginBottom: "0.5rem" }}>
                  <span>
                    {t("product.archive_question")}{" "}
                    <span style={{ fontWeight: "bold", color: "#000" }}>
                      {state.rowData?.name}
                    </span>{" "}{"?"}{" "}
                  </span>
                </div>
                <p className="archive-notice">
                  {t("product.archive_notice")}
                </p>
              </div>
              <hr style={{ border: "1px solid #F2F2F2" }} />
            </div>
          </Dialog>
          <div>
            <DataTable
              sortField="createdOn"
              sortOrder={-1}
              id="data_table"
              value={doc}
              filters={filters}
              globalFilterFields={[
                "name",
                "country.name",
                "status",
                "tierObject.tierName",
                "billingObject",
                "planName",
                "billingPeriod",
                "newPlan.billingPeriod",
              ]}
              emptyMessage={t("product.not_found")}
              className="p-datatable-responsive-table transactions-table"
              responsiveLayout="stack"
              breakpoint="1050px"
              paginator
              rows={10}
              dataKey="id"
              loading={loadingTable}
              expandedRows={expandedRows}
              rowExpansionTemplate={rowExpansionTemplate}
              onRowToggle={(e) => {
                setExpandedRows(e.data);
              }}
            >
              {(!isMobileStack || checked) && (
                <Column
                  field="archive"
                  body={archiveTemplate}
                  className={`datatable-cell-default ${checked && "archive-cell"
                    } archive-icon`}
                  headerClassName="datatable-header-default header-title "
                />
              )}
              <Column
                headerClassName="datatable-header-default header-title"
                expander
                className={`datatable-cell-default products-mobile-expander ${checked && "archive-cell"
                  } chevron table_dropdown`}
              />
              {columns.map(
                ({ field, body, header, sort, style, className = "" }, i) => (
                  <Column
                    key={i}
                    field={field}
                    body={body}
                    header={header}
                    alignHeader="left"
                    className={`datatable-cell-default ${checked && "archive-cell"
                      } ${className}`}
                    headerClassName={"datatable-header-default header-title "}
                    style={{ ...style }}
                    sortable={sort}
                  />
                )
              )}
            </DataTable>
          </div>
        </>
      )}
    </>
  );
};

export default ProductDataTable;